const PROTECTED_DEMO_COUPLE_EMAILS = [
  "tkolkebeck@me.com",
  "tkolkebeck@satx.rr.com",
  "jimmieflores@gmail.com",
  "dulceaflores@gmail.com",
] as const;

export function isProtectedDemoCouple(
  hisEmail?: string | null,
  herEmail?: string | null,
): boolean {
  return (
    hisEmail === PROTECTED_DEMO_COUPLE_EMAILS[0] ||
    herEmail === PROTECTED_DEMO_COUPLE_EMAILS[1] ||
    hisEmail === PROTECTED_DEMO_COUPLE_EMAILS[2] ||
    herEmail === PROTECTED_DEMO_COUPLE_EMAILS[3]
  );
}
